module.exports = __webpack_public_path__ + "static/educators_devices-b76396951c9036e4e1f9bccf76b4278a.png";